import { services } from '@nvision/oidc';

export const checkIdentityLogin = () => {
  const isIdentityLogin = !services.auth.isOIDCProviderDisabled();

  return {
    isIdentityLogin,
  };
};
